import React from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import { getPendingTrainingRequests, approveTrainingRequest } from '../../../services/serviceRequestService';
import { ServiceRequest } from '../../../types/serviceRequest';

import LoadingSpinner from '../../../components/common/LoadingSpinner';
import ErrorAlert from '../../../components/common/ErrorAlert';
import pageStyles from '../../Page.module.css';

const TrainingRequestsList: React.FC = () => {
  const queryClient = useQueryClient();

  // !! التعديل الرئيسي هنا !!
  // 1. لا نحدد النوع في useQuery
  // 2. نحدد النوع في queryFn
  const { data: requests, isLoading, isError, error } = useQuery({
    queryKey: ['pendingTrainingRequests'],
    queryFn: (): Promise<ServiceRequest[]> => getPendingTrainingRequests(),
  });

  const approveMutation = useMutation({
    mutationFn: approveTrainingRequest,
    onSuccess: () => {
      toast.success('تمت الموافقة على الطلب بنجاح!');
      queryClient.invalidateQueries({ queryKey: ['pendingTrainingRequests'] });
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'فشلت عملية الموافقة.');
    },
  });

  const handleApprove = (requestId: number) => {
    approveMutation.mutate(requestId);
  };

  // 3. حالات التحميل والخطأ تبقى كما هي
  if (isLoading) return <LoadingSpinner />;
  if (isError) return <ErrorAlert message={error.message} />;

  // 4. الآن TypeScript يفهم أن 'requests' هو إما 'ServiceRequest[]' أو 'undefined'
  return (
    <div className={pageStyles.pageContainer}>
      <h1 className={pageStyles.pageTitle}>طلبات الالتحاق بالتدريب</h1>

      {/* هذا الشرط الآن صحيح ويعمل كما هو متوقع */}
      {requests && requests.length > 0 ? (
        <div className={pageStyles.tableContainer}>
          <table>
            <thead>
              <tr>
                <th>اسم المشترك</th>
                <th>البريد الإلكتروني</th>
                <th>تاريخ الطلب</th>
                <th>رسالة الدافع</th>
                <th>إجراءات</th>
              </tr>
            </thead>
            <tbody>
              {/* داخل هذا البلوك، TypeScript متأكد أن 'requests' هو مصفوفة */}
              {requests.map((req) => (
                <tr key={req.id}>
                  <td>{req.user?.subscriber?.name || 'غير متوفر'}</td>
                  <td>{req.user?.email}</td>
                  <td>{new Date(req.created_at).toLocaleDateString('ar-EG')}</td>
                  <td>{req.documents?.motivationLetter || 'لا يوجد'}</td>
                  <td>
                    <button
                      onClick={() => handleApprove(req.id)}
                      disabled={approveMutation.isPending}
                      className="button primary"
                    >
                      {approveMutation.isPending ? 'جاري...' : 'موافقة'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>لا توجد طلبات تدريب جديدة في الوقت الحالي.</p>
      )}
    </div>
  );
};

export default TrainingRequestsList;
